/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchemaOptional } from './ClaimsSchemaOptional';

export const CredentialSchemaCreate: core.serialization.ObjectSchema<
    serializers.CredentialSchemaCreate.Raw,
    Truvity.CredentialSchemaCreate
> = core.serialization.object({
    fromPublishedSchemaUrl: core.serialization.property(
        'from_published_schema_url',
        core.serialization.string().optional(),
    ),
    fromSchema: core.serialization.property('from_schema', core.serialization.string().optional()),
    schema: ClaimsSchemaOptional.optional(),
});

export declare namespace CredentialSchemaCreate {
    export interface Raw {
        from_published_schema_url?: string | null;
        from_schema?: string | null;
        schema?: ClaimsSchemaOptional.Raw | null;
    }
}
